import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  const publicUrl = process.env.PUBLIC_URL || '';
  return (
    <footer className="footer">
      <p className="footer__line">
        &copy; {year} TalentVibe. All rights reserved. A{' '}
        <img
          className="footer__govcom-inline"
          src={`${publicUrl}/govcom-solutions-logo.png`}
          alt="GovCom"
        />{' '}
        Product
        {' · '}
        <Link to="/contact" className="footer__link">
          Contact us
        </Link>
        {' · '}
        <Link to="/support" className="footer__link">
          Support
        </Link>
      </p>
    </footer>
  );
}

export default Footer;
